var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorder3TopRight = function SvgBorder3TopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 368,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.501 367.5V31.252c0-16.568-13.431-30-30-30H0",
    stroke: "#000"
  })));
};

export default SvgBorder3TopRight;